export enum ForUseAs {
  approved = 'approved',
  restricted = 'restricted',
}

export type ClientLocation = {
  clientBC: string; // Code identifying the Client, minLength: 1, maxLength: 30
  namedLocationUUID: string; // The NamedLocation associated with the client, must be a UUID
  description: string; // Description of the purpose of this Client Location entry
  forUseAs: string; // What is this location to be used for? Enum values are not specified here.
  clientLocationUUID: string; // Globally unique identifier of this client location, must be a UUID
  modifiedByUserID: string; // ID of the last user to modify this entity; or SYSTEM, minLength: 1
  modifiedDateTimeUTC: string; // The last time this entity was modified, must be a date-time string
  correlationUUID: string; // Application-wide unique ID for this entity instance, must be a UUID
};

export type CreatableClientLocation = {
  clientBC: string; // Code identifying the Client, minLength: 1, maxLength: 30
  namedLocationUUID: string; // The NamedLocation associated with the client, must be a UUID
  description: string; // Description of the purpose of this Client Location entry
  forUseAs: ForUseAs; // What is this location to be used for?
};

export type DeleteClientLocationRequest = {
  clientBC: string;
  clientLocationUUID: string;
};
